import * as React from 'react';
import {Helmet} from 'react-helmet';
import {toast} from 'react-toastify';
import {useRoute} from 'react-router5';
import {createProgram} from 'api/program/requests';
import {TrainingBuilder} from 'components/TrainingBuilder';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';

/**
 * Create training program page.
 * @return {React.ReactElement}
 * @constructor
 */
export default function CreateTraining(): React.ReactElement {
  const {router} = useRoute();

  return (
    <React.Fragment>
      <Helmet>
        <title>FitPlace / Создать тренеровку</title>
      </Helmet>
      <TrainingBuilder
        onCreate={(data) => (
          createProgram('gym', data).then((response) => {
            validateResponse(response);

            if (response && !isError(response)) {
              toast.success('Программа тренеровок создана');
              router.navigate('trainings');
            }
          })
        )}
      />
    </React.Fragment>
  );
}
